import React from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Icon, message } from 'antd';
import Btn from '../../../../../../components/btn';
import { useFormMethods } from '../../../../../../helpers/formManager';
import { actionCreators, sliceKeys } from '../../../../model';
import { useCreateNewConfigMutation } from '../../../../api/createNewConfig';
import { useAcceptanceViewInfoInvalidate } from '../../../../api/acceptanceViewInfo';
import { useModalMethods } from '../../../../shared/packages/modalManager';
import { modalNames } from '../../../../shared/configs/modal';
import { mapNewConfigValuesToPayload } from '../../../../services/acceptancePayloadMapper';
import { useCheckDesksBusyWithCb } from '../../../../controllers/checkDesksBusy';
import { fieldNames } from '../../../../shared/configs/acceptanceForm';
import { useAcceptanceViewFlatsInvalidate } from '../../../../api/acceptanceViewFlats';

const { newConfigPageReset } = actionCreators[sliceKeys.newConfigPage];

const {
  fromDate: fromName,
  toDate: toName,
  desks: desksName,
} = fieldNames.main;

const newConfigFail = (msg) => {
  message.error(msg || 'Не удалось создать новую конфигурацию');
};

const SaveNewConfig = () => {
  const history = useHistory();

  const { handleSubmit } = useFormMethods();

  const { close } = useModalMethods();

  const dispatch = useDispatch();

  const invalidateAcceptanceViewInfo = useAcceptanceViewInfoInvalidate();
  const invalidateFlats = useAcceptanceViewFlatsInvalidate();

  const { check, isLoading: isCheckLoading } = useCheckDesksBusyWithCb();

  const { mutate, isLoading } = useCreateNewConfigMutation({
    onSuccess: (data) => {
      if (!data.success) {
        newConfigFail(data.message);
        return;
      }

      const { push, location } = history;

      close(modalNames.changeAcceptanceDate);

      invalidateAcceptanceViewInfo();
      invalidateFlats();

      push(location.state.from.location);

      dispatch(newConfigPageReset());
    },
  });

  const onSubmit = (values) => {
    const { state } = history.location;

    const payload = mapNewConfigValuesToPayload(
      excludeDateKey(values, state?.from?.excludeDateKey)
    );

    check(
      {
        [fromName]: payload[fromName] ?? state.from.values[fromName],
        [toName]: payload[toName] ?? state.from.values[toName],
        [desksName]: payload[desksName],
      },
      () => mutate(payload)
    );
  };

  const loading = isLoading || isCheckLoading;

  return (
    <Btn onClick={handleSubmit(onSubmit)} disabled={loading}>
      <span>Сохранить</span>
      <Icon type={loading ? 'loading' : 'check'} style={{ height: '14px' }} />
    </Btn>
  );
};

export default SaveNewConfig;

function excludeDateKey(values, key) {
  const { [key]: excludeProp, ...rest } = values;
  return rest;
}
